import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  Grid,
  TextField,
  Divider,
  IconButton,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddBoxRoundedIcon from "@material-ui/icons/AddBoxRounded";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";
import FacebookCampaignContext from "../../../../context/facebook_profiles/campaign/CampaignContext";
import FacebookAdSetContext from "../../../../context/facebook_profiles/adset/AdSetContext";

// Components
import Form from "./Form";
import CancelAlert from "./CancelAlert";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    marginLeft: "8px",
    height: 700,
  },
  paperBox: {
    padding: "0.5rem",
  },
  row: {
    width: "100%",
  },
  divider: {
    width: "100%",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  title: {
    fontSize: "0.9rem",
    marginLeft: "0.5rem",
  },
  addBox: {
    "&:focus": {
      outline: "none",
    },
  },
  addButton: {
    color: theme.palette.text.primary,
  },
  rowForm1: {
    height: 441,
    width: "99%",
    overflowY: "auto",
    margin: "1rem auto 1rem",
  },
  rowForm2: {
    height: 384,
    width: "99%",
    overflowY: "auto",
    margin: "1rem auto 1rem",
  },
  rowForm3: {
    height: 363,
    width: "99%",
    overflowY: "auto",
    margin: "1rem auto 1rem",
  },
  rowPaper: {
    width: "99%",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    marginBottom: "0.5rem",
  },
  buttonBox: {
    textAlign: "center",
    marginLeft: "0.5rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const CreateAdSet = () => {
  const classes = useStyles();

  const {
    selected_fb_details,
    selected_profile,
    setDisplayContent,
    getCampaignStats,
    campaign_stats,
  } = useContext(FacebookProfilesDashboardContext);
  const { campaign_id } = useContext(FacebookCampaignContext);
  const {
    default_form,
    default_error,
    form_details,
    setFormDetails,
    form_errors,
    setFormErrors,
    resetForm,
    createAdSet,
  } = useContext(FacebookAdSetContext);

  const [bm, setBm] = useState();
  const [ad, setAd] = useState();
  const [pixels, setPixels] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [campid, setCampid] = useState(campaign_id);
  const [campidError, setCampidError] = useState("");

  const modalClose = () => {
    // Continue Edit Ad Set
    setModalOpen(false);
  };

  const modalSave = () => {
    // Back To Overview
    setDisplayContent();
    resetForm();
  };

  const handleChange = (e) => {
    // Campaign ID Selection
    setCampid(e.target.value);
    setCampidError("");
  };

  const handleDuplicate = () => {
    let name_list = {};

    // Cross Check Duplicate Ad Set Name
    form_details.map((each, index) => {
      if (each.name) {
        if (!Object.keys(name_list).includes(each.name)) {
          name_list[each.name] = [index];
        } else {
          name_list[each.name].push(index);
        }
      }
    });

    // Remove Error Message
    form_errors.map((error) => {
      error["name"] = "";
    });

    // Insert Error Message
    Object.values(name_list).map((indexes) => {
      if (indexes.length > 1) {
        indexes.map((index) => {
          form_errors[index]["name"] = "Ad set name duplicated!";
        });
      }
    });

    setFormDetails(form_details);
    setFormErrors(form_errors);
  };

  const addAdSet = (e, pixel_id) => {
    // Add New Ad Set
    let last_idx = Object.keys(form_details).pop();
    last_idx = last_idx ? last_idx : 0;
    const new_idx = last_idx === 0 ? 0 : parseInt(+last_idx + 1);

    // Insert Default Pixel
    if (!pixel_id) {
      if (pixels.length > 0) pixel_id = pixels[0].id;
      else pixel_id = "";
    }

    let dup_form = JSON.parse(JSON.stringify(default_form));
    dup_form.pixel_id = pixel_id;

    form_details[new_idx] = dup_form;
    form_errors[new_idx] = default_error;

    setFormDetails(form_details);
    setFormErrors(form_errors);
  };

  const removeAdSet = (e) => {
    // Remove Ad Set
    form_details.splice(e.target.name, 1);
    form_errors.splice(e.target.name, 1);

    // Prevent Empty Ad Set
    if (Object.keys(form_details).length === 0) {
      addAdSet();
    }

    handleDuplicate();
  };

  const onCancel = () => {
    // Open Modal - Cancel Creation
    setModalOpen(true);
  };

  const onCreate = (e) => {
    // Save Ad Sets
    e.preventDefault();

    let next = true;

    if (!campid) {
      setCampidError("Select one campaign!");
      next = false;
    }

    form_errors.map((error) => {
      Object.values(error).map((err) => {
        if (err) next = false;
      });
    });

    form_details.map((details, index) => {
      Object.entries(details).map(([id, val]) => {
        if (id === "countries") {
          if (val.length === 0) {
            form_errors[index][id] = "Select at least one country!";
            next = false;
          }
        } else {
          let name;

          if (id === "name") name = "Name";
          else if (id === "billing_event") name = "Billing Event";
          else if (id === "optimization_goal") name = "Optimization Goal";
          else if (id === "pixel_id") name = "Pixel ID";
          else if (id === "custom_event_type") name = "Custom Event Type";
          else if (id === "spec_event_type")
            name = "Attribution Spec - Event Type";

          if (val === "") {
            form_errors[index][id] = `${name} cannot be empty!`;
            next = false;
          }
        }
      });
    });

    setFormDetails(form_details);
    setFormErrors(form_errors);

    if (next)
      createAdSet(selected_profile.profile_id, ad.ad_account_id, campid);
  };

  useEffect(() => {
    selected_profile.bm_account.map((bm) => {
      if (bm.bm_account_id === selected_fb_details.business_manager) {
        setBm(bm);
      }
    });

    selected_profile.ad_account.map((ad) => {
      if (ad.ad_account_id === selected_fb_details.ad_account) {
        setAd(ad);
        setPixels(ad.pixels);
        // Onload Create New Ad Set
        addAdSet("button", ad.pixels[0] && ad.pixels[0].id);
      }
    });

    // Get Campaign List
    getCampaignStats(selected_profile);
  }, []);

  return (
    <Paper className={classes.paper}>
      <CancelAlert
        modalOpen={modalOpen}
        modalClose={modalClose}
        modalSave={modalSave}
      />
      <Grid
        container
        className={classes.paperBox}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item className={classes.row}>
          <Grid item xs={4} container direction="column" spacing={1}>
            <Grid item>
              <TextField
                fullWidth
                disabled
                size="small"
                margin="dense"
                label="Business Manager"
                id="business_manager"
                name="business_manager"
                value={bm ? `${bm.bm_account_name} (${bm.bm_account_id})` : ""}
              />{" "}
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                disabled
                size="small"
                margin="dense"
                label="Ad Account"
                id="ad_account"
                name="ad_account"
                value={ad ? `${ad.ad_account_name} (${ad.ad_account_id})` : ""}
              />{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item className={classes.divider}>
          <Divider variant="fullWidth" />
        </Grid>
        {!campaign_id && (
          <Grid item xs={5} className={classes.rowPaper}>
            <TextField
              required
              fullWidth
              variant="outlined"
              select
              SelectProps={{
                native: true,
              }}
              size="small"
              margin="dense"
              label="Campaign"
              id="campid"
              name="campid"
              value={campid ? campid : "select"}
              onChange={handleChange}
              error={campidError ? true : false}
              helperText={campidError ? campidError : ""}
            >
              <option value="select" disabled>
                -- - select one-- -
              </option>{" "}
              {campaign_stats.map((each) => {
                return (
                  <option key={each.id} value={each.id}>
                    {" "}
                    {each.name}({each.id}){" "}
                  </option>
                );
              })}{" "}
            </TextField>{" "}
          </Grid>
        )}
        <Grid item className={classes.row}>
          <div>
            <span className={classes.title}> Ad Set: </span>&ensp;{" "}
            <IconButton
              size="small"
              onClick={addAdSet}
              className={classes.addBox}
            >
              <AddBoxRoundedIcon className={classes.addButton} />{" "}
            </IconButton>{" "}
          </div>{" "}
        </Grid>
        <Grid
          item
          className={
            campaign_id
              ? classes.rowForm1
              : campidError
              ? classes.rowForm3
              : classes.rowForm2
          }
        >
          {form_details.map((adset, index) => {
            return (
              <Form
                key={index}
                adset_id={index}
                adset_details={adset}
                list_pixel={pixels}
                remove={removeAdSet}
                handleDuplicate={handleDuplicate}
              />
            );
          })}{" "}
        </Grid>
        <Grid
          item
          className={classes.row}
          container
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={onCancel}
            >
              Cancel{" "}
            </Button>{" "}
          </Grid>
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={onCreate}
            >
              Next{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default CreateAdSet;
